import TransferError from 'features/moveMoney/screens/transfer/TransferError/TransferError';
import React from 'react';

export default function TransferErrorPage() {
  return <TransferError />;
}
